<template lang="pug">
  .ration-settings-dropdown
    v-dropdown(
      ref="dropdown"
      width-auto
      position-right)
      v-btn(icon @click="onToggle"
      )
        v-icon(
          font-size="1.1"
          icon="cog")
      .ration-settings-dropdown__content(
        v-click-outside="closeClick"
        ref="dropdownContent"
        slot="content")
        v-card(
          elevated)
          v-card-title(v-if="!locked && allowChange")
            h2.card-title {{ 'base.loading_params' | translate }}
            v-text-field.mt-2(
              :focus="true"
              :label="$t('base.name')"
              v-model="item.name")
            div(@click="handleAutoLoadClick")
              v-switch.mb-3(
                :label="$t('base.auto_load')"
                :disabled="item.is_adjustment_leftovers || planningDataLoading"
              
              v-model="item.auto_load")
            v-switch.mb-3(
              :label="$t('base.activate')"
              :disabled="planningDataLoading"
              v-model="item.is_active")
            v-switch.mb-3(
              :disabled="planningDataLoading"
              :label="$t('base.correction')"
              v-model="item.correction")
            div(@click="handleAdjustmentLeftoversClick")  
              v-switch.mb-3(
                :label="$t('base.leftovers')"
                :disabled="item.auto_load || planningDataLoading"
                v-model="item.is_adjustment_leftovers")
            v-range.mt-2.mb-3(
              v-if="item.is_adjustment_leftovers"
              :min="0"
              :max="100"
              :label="$t('base.leftovers_planning')"
              v-model="item.leftovers_percent")
          v-divider(
            secondary)
          v-card-title
            h2.card-title.mb-3 {{ 'base.action' | translate }}
          v-card-actions
            .ration-settings-dropdown__group(
              v-if="isLoadAvailable && allowLoad")
              v-btn(
                small
                ghost
                @click="loadClick")
                v-icon(
                  position-left
                  font-size="1"
                  icon="arrow-up")
                span {{ 'base.self_load' | translate }}
            .ration-settings-dropdown__group(
              v-if="isUploadAvailable && allowUpload")
              v-btn(
                small
                ghost
                @click="uploadClick")
                v-icon(
                  position-left
                  font-size="1"
                  icon="arrow-down")
                span {{ 'base.self_upload' | translate }}
            .ration-settings-dropdown__group
              v-btn(
                ghost
                small
                @click="copyClick")
                v-icon(
                  position-left
                  font-size="1"
                  icon="copy")
                span {{ 'base.copy' | translate }}
            .ration-settings-dropdown__group(
              v-if="!locked && allowDelete")
              delete-btn(
                @delete="deleteSchedule")
                v-btn(
                  small
                  danger
                  ghost)
                  v-icon(
                    position-left
                    font-size="1"
                    :icon="['far', 'trash-alt']")
                  span {{ 'base.delete' | translate }}
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'RationSettingsDropdown',

  components: {
    DeleteBtn
  },

  props: {
    item: Object
  },
  data: () => ({
    isDropdownOpen: false,
    hasChanges: false,
  }),

  mounted () {
    if (this.item.name === 'schedule name') {
      this.item.name = this.item.schedule_ration.name
    }
  },

  computed: {
    ...mapGetters('planning', [
      'isPlanningLoading'
    ]),
    planningDataLoading () {
      return this.isPlanningLoading
    },
    isLoadAvailable () {
      return this.item.status === 'waited' || this.item.status === 'in_process'
    },

    isUploadAvailable () {
      return this.item.status === 'loaded' || this.item.status === 'out_process'
    },

    locked () {
      return this.item.deleted ||
      this.item.changed ||
      this.item.status === 'loaded' ||
      this.item.schedule_loading.deleted
    },

    allowLoad () {
      return this.hasPermission('load_schedule', 'add')
    },

    allowUpload () {
      return this.hasPermission('upload_schedule', 'add')
    },

    allowDelete () {
      return this.hasPermission('schedule', 'delete')
    },

    allowChange () {
      return this.hasPermission('schedule', 'change')
    }
  },

  methods: {
    onToggle () {
      if (this.isDropdownOpen) {
        this.updateItem()
      }
      this.isDropdownOpen = !this.isDropdownOpen
    },
    closeClick (event) {
      const dropdown = this.$refs.dropdown
      const dropdownContent = this.$refs.dropdownContent

      if (
        (dropdown && dropdown.$el && dropdown.$el.contains(event.target)) ||
        (dropdownContent && dropdownContent.contains && dropdownContent.contains(event.target))
      ) {
        return
      }

      if (this.isDropdownOpen) {
        this.updateItem()
        this.isDropdownOpen = false
      }
    },

    async updateItem () {
      if (!this.locked) {
        await api.schedule.updateById(this.item.id, this.item)
        this.$emit('updated')
      }
      this.$emit('close')
    },

    async deleteSchedule () {
      await api.schedule.deleteById(this.item.id)
      this.$emit('updated')
      this.$emit('close')
    },

    copyClick () {
      this.$refs.dropdown.closeDropdown()
      this.$emit('on-copy')
    },

    loadClick () {
      this.$refs.dropdown.closeDropdown()
      this.$emit('on-load')
    },

    uploadClick () {
      this.$refs.dropdown.closeDropdown()
      this.$emit('on-upload')
    },

    close () {
      this.$emit('on-close')
    },
    handleAutoLoadClick (event) {
      this.hasChanges = true
      if (this.item.is_adjustment_leftovers) {
        this.item.auto_load = false
        this.$toasted.error(this.$t('base.auto_load_disabled'))
        event.preventDefault()
      }
    },
    handleAdjustmentLeftoversClick (event) {
      this.hasChanges = true
      if (this.item.auto_load) {
        this.item.is_adjustment_leftovers = false
        this.$toasted.error(this.$t('base.lefovers_disabled'))
        event.preventDefault()
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.ration-settings-dropdown {

  &__content {
    width: 38rem;
  }

  &__group:not(:last-child) {
    margin-bottom: 2rem;
  }
}
</style>
